import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

/**
 * Guard that blocks non-Development users from accessing /dev routes.
 *
 * ROLE ACCESS:
 * - Development: ✅
 * - Others: ❌ → redirect to their default route
 */
export const DevelopmentGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authState = inject(AuthState);

  if (!authState.hasDevelopmentAccess()) {
    console.log('[DevelopmentGuard] Access denied - redirecting to:', authState.defaultRoute());
    router.navigate([authState.defaultRoute()]);
    return false;
  }

  return true;
};
